import { FC, useMemo } from 'react'
import { GetServerSideProps } from 'next'

import SEOBreadCrumbs from 'components/parts/seo-metatags/seo-breadcrumbs'
import SEOMetatags from 'components/parts/seo-metatags/seo-metatags'
import WebinarPageSearch from 'containers/webinar-layout/webinar-layout'

import { WebinarTargetSEO } from 'constants/SEO'
import { WebinarTargetBC } from 'constants/SEO-breadcrumbs'
import { ITargetPage } from 'constants/types/common.types'
import getPropsTargetPage from 'utils/server-side/getPropsTargetPage'

const WebinarTargetPage: FC<ITargetPage> = ({
  genForm,
  doctorForm,
  targetLink,
  targetInitParams,
  isNoIndex,
}) => {
  const title = `Вебинары по ${genForm}`

  const SEOData = useMemo(
    () => ({
      metatags: WebinarTargetSEO(genForm, doctorForm, targetLink),
      breadcrumbs: WebinarTargetBC({ id: targetLink, name: title }),
    }),
    []
  )

  return (
    <>
      <SEOMetatags data={SEOData.metatags} nofollow={isNoIndex} />
      <SEOBreadCrumbs data={SEOData.breadcrumbs} />
      <WebinarPageSearch title={title} targetInitParams={targetInitParams} />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = getPropsTargetPage(
  `/api/webinar?StatusId=1&count=true&limit=1&offset=0`
)

export default WebinarTargetPage
